var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "h-table account-history" },
    [
      _c("thead", [
        _c(
          "tr",
          _vm._l(_vm.columns, function (column) {
            return _c(
              "th",
              {
                key: column.id,
                staticClass: "h-table__col-title",
                class: {
                  [column.className]: true,
                  active: _vm.sortBy === column.sort,
                },
                on: {
                  click: function ($event) {
                    return _vm.sort(column.sort)
                  },
                },
              },
              [_vm._v(" " + _vm._s(column.title) + " ")]
            )
          }),
          0
        ),
      ]),
      _vm._l(_vm.dates, function (date) {
        return [
          date.resume
            ? [
                _c(
                  "tr",
                  {
                    key: "operations-date-" + date.unique,
                    staticClass: "h-table__row operations-date",
                    class: {
                      "h-table__row--header": date.open,
                      "operations-date--open": date.open,
                    },
                  },
                  _vm._l(_vm.columns, function (column) {
                    return _c("cell", {
                      key: column.id,
                      attrs: {
                        column: column,
                        date: date,
                        edit: _vm.edit,
                        toggler: true,
                      },
                      on: {
                        toggle: function ($event) {
                          date.open = !date.open
                        },
                      },
                    })
                  }),
                  1
                ),
              ]
            : _vm._e(),
          _c(
            "transition",
            { key: `operations-${date.unique}`, attrs: { name: "slide" } },
            [
              !date.resume || date.open
                ? _c(
                    "tbody",
                    { staticClass: "slide-transition" },
                    _vm._l(date.operations, function (operation) {
                      return _c(
                        "tr",
                        {
                          key: operation.unique,
                          staticClass: "h-table__row",
                          class: {
                            "h-table__row--header": date.resume && date.open,
                          },
                        },
                        _vm._l(_vm.columns, function (column) {
                          return _c("cell", {
                            key: column.id,
                            attrs: {
                              column: column,
                              date: date,
                              operation: operation,
                              edit: _vm.edit,
                              "can-remove": _vm.canRemove,
                            },
                            on: {
                              remove: function ($event) {
                                return _vm.remove(operation)
                              },
                              restore: function ($event) {
                                return _vm.restore(operation)
                              },
                            },
                          })
                        }),
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ]
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }